module.exports = __webpack_public_path__ + "img/battles.b59a7bfc.png";